import { Component, HostBinding, input } from '@angular/core';
import { MatToolbar } from '@angular/material/toolbar';
import { RouterLink } from '@angular/router';
import { BottomNavItem } from '../bottom-nav';
import { BottomNavButtonComponent } from '../bottom-nav-button/bottom-nav-button.component';
import { MatIcon } from '@angular/material/icon';

/**
 * This component is a [Material-style bottom navigation bar]{@link https://material.io/design/components/bottom-navigation.html}.
 * It receives an array of [BottomNavItems]{@link BottomNavItem} in order to render navigation buttons.
 * With [Material theming]{@link https://github.com/latusinski/ngx-drawer-layout#enabling-material-theming}
 * enabled, this component changes its style, when the {@link color} property.
 */
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ngx-bottom-nav',
  templateUrl: './bottom-nav.component.html',
  styleUrls: ['./bottom-nav.component.scss'],
  imports: [MatToolbar, BottomNavButtonComponent, RouterLink, MatIcon]
})
export class BottomNavComponent {
  /**
   * Navigation old-items, which are rendered inside the navigation bar.
   */
  readonly items = input<BottomNavItem[]>([]);

  /**
   * The color of this navigation bar, following the logic of Angular Material
   */
  readonly color = input.required<'primary' | 'accent' | 'warn'>();

  @HostBinding('class.color-primary')
  get colorPrimary(): boolean {
    return this.color() === 'primary';
  }

  @HostBinding('class.color-accent')
  get accentPrimary(): boolean {
    return this.color() === 'accent';
  }

  @HostBinding('class.color-warn')
  get warnPrimary(): boolean {
    return this.color() === 'warn';
  }

  /**
   * Returns true if the length of {@link items} is greater than 4, which hides labels on inactive old-items.
   */
  @HostBinding('class.hide-labels')
  get hideLabels(): boolean {
    return this.items().length > 4;
  }
}
